import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_APPLICATION_OWNER,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
  CAMPAIGNTYPE_SELF_CERTIFICATION,
  CAMPAIGNTYPE_SERVICEACCOUNT,
  CAMPAIGNTYPE_USERMANAGER,
} from '../../../utils/constant';

import {
  ACC_CERT_ENTITLEMENT_VALUEKEY,
  AO_DEFAULT_ROW_FILTER,
  ENT_CERT_ENTITLEMENT_VALUEKEY,
  EO_ACC_CERT_ENTITLEMENT_VALUEKEY,
  EO_CHILD_CERT_ENTITLEMENT_VALUEKEY,
  EO_DEFAULT_ROW_FILTER,
  EO_ENT_CERT_ENTITLEMENT_VALUEKEY,
  EO_OBJECTS_TO_BE_INCLUDED_ACCOUNTS,
  EO_OBJECTS_TO_BE_INCLUDED_CHILD_ENTITLEMENTS,
  EO_OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS,
  EO_ROWS_CONSTANT_MAP,
  OBJECTS_TO_BE_INCLUDED_ACCOUNTS,
  OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS,
  OBJECTS_TO_BE_INCLUDED_ROLES,
  OBJECTS_TO_BE_INCLUDED_USERS,
  RLE_CERT_ENTITLEMENT_VALUEKEY,
  ROWS_CONSTANT_MAP,
  UM_DEFAULT_ROW_FILTER,
  USR_CERT_ENTITLEMENT_VALUEKEY,
} from './constant';

export const getDefaultRowFilter = (campaignType) => {
  const currentCampaignType = CAMPAIGN_TYPES[campaignType];

  switch (currentCampaignType) {
    case CAMPAIGNTYPE_APPLICATION_OWNER:
    case CAMPAIGNTYPE_SERVICEACCOUNT:
      return AO_DEFAULT_ROW_FILTER;
    case CAMPAIGNTYPE_ENTITLEMENTOWNER:
      return EO_DEFAULT_ROW_FILTER;
    case CAMPAIGNTYPE_USERMANAGER:
    case CAMPAIGNTYPE_SELF_CERTIFICATION:
      return UM_DEFAULT_ROW_FILTER;
    default:
      return [];
  }
};

export const assignCountToRowFilterTree = (filters, appliedRowFilters) => {
  const getCountAndCheck = (tree, countObj = { value: 0 }) =>
    tree.map((filter) => {
      const updatedFilter = {
        ...filter,
        count: countObj.value,
        isChecked: appliedRowFilters.includes(filter.value),
      };

      // eslint-disable-next-line no-param-reassign
      countObj.value += 1;

      if (filter.options && filter.options.length > 0) {
        updatedFilter.options = getCountAndCheck(filter.options, countObj);
      }

      return updatedFilter;
    });

  return getCountAndCheck(filters);
};

export const getActiveFiltersForRows = (arr) => {
  const tempArr = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i].isDisabled === false) tempArr.push(arr[i].value);

    if (arr[i].options.length !== 0) {
      tempArr.push(...getActiveFiltersForRows(arr[i].options));
    }
  }

  return tempArr;
};

export const getCheckedFiltersForRows = (arr) => {
  const tempArr = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i].isChecked === true && arr[i].isDisabled === false)
      tempArr.push(arr[i].value);

    if (arr[i].options.length !== 0) {
      tempArr.push(...getCheckedFiltersForRows(arr[i].options));
    }
  }

  return tempArr;
};

export const reMapRowsFilterTree = (filterTree, viewRowsList, campaignType) => {
  const tempTree = JSON.parse(JSON.stringify(filterTree));

  const reMapIsDisabled = (tree) => {
    tree.forEach((obj) => {
      if (CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER) {
        if (
          obj.value === EO_ACC_CERT_ENTITLEMENT_VALUEKEY &&
          !viewRowsList.includes(EO_OBJECTS_TO_BE_INCLUDED_ACCOUNTS)
        ) {
          // eslint-disable-next-line no-param-reassign
          obj.isDisabled = true;
        }

        if (
          obj.value === EO_ENT_CERT_ENTITLEMENT_VALUEKEY &&
          !viewRowsList.includes(EO_OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS)
        ) {
          // eslint-disable-next-line no-param-reassign
          obj.isDisabled = true;
        }

        if (
          obj.value === EO_CHILD_CERT_ENTITLEMENT_VALUEKEY &&
          !viewRowsList.includes(EO_OBJECTS_TO_BE_INCLUDED_CHILD_ENTITLEMENTS)
        ) {
          // eslint-disable-next-line no-param-reassign
          obj.isDisabled = true;
        }
      } else {
        if (
          obj.value === USR_CERT_ENTITLEMENT_VALUEKEY &&
          !viewRowsList.includes(OBJECTS_TO_BE_INCLUDED_USERS)
        ) {
          // eslint-disable-next-line no-param-reassign
          obj.isDisabled = true;
        }

        if (
          obj.value === RLE_CERT_ENTITLEMENT_VALUEKEY &&
          !viewRowsList.includes(OBJECTS_TO_BE_INCLUDED_ROLES)
        ) {
          // eslint-disable-next-line no-param-reassign
          obj.isDisabled = true;
        }

        if (
          obj.value === ACC_CERT_ENTITLEMENT_VALUEKEY &&
          !viewRowsList.includes(OBJECTS_TO_BE_INCLUDED_ACCOUNTS)
        ) {
          // eslint-disable-next-line no-param-reassign
          obj.isDisabled = true;
        }

        if (
          obj.value === ENT_CERT_ENTITLEMENT_VALUEKEY &&
          !viewRowsList.includes(OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS)
        ) {
          // eslint-disable-next-line no-param-reassign
          obj.isDisabled = true;
        }
      }

      if (obj.options.length > 0) reMapIsDisabled(obj.options);
    });
  };

  reMapIsDisabled(tempTree);

  const reCreateHierarchy = (tree) => {
    const _tempTree = [];

    tree.forEach((obj) => {
      if (!obj.isDisabled) {
        _tempTree.push({
          ...obj,
          options:
            (obj?.options && obj.options.length) > 0
              ? reCreateHierarchy(obj.options)
              : [],
        });
      } else if (obj.options && obj.options.length > 0) {
        _tempTree.push(...reCreateHierarchy(obj.options));
      }
    });

    return _tempTree;
  };

  const reMapIsParent = (tree) => {
    tree.forEach((obj) => {
      // eslint-disable-next-line no-param-reassign
      obj.isParent = true;
    });
  };

  const hierarchyTree = reCreateHierarchy(tempTree);

  reMapIsParent(hierarchyTree);

  return hierarchyTree;
};

export const getCountOfAvailableFilters = (filters) => {
  let count = 0;

  const _getCountOfAvailableFilters = (_filters) => {
    _filters.forEach((filter) => {
      if (filter.isDisabled === false) {
        count += 1;
      }

      if (filter?.options?.length > 0) {
        _getCountOfAvailableFilters(filter.options);
      }
    });
  };

  _getCountOfAvailableFilters(filters);

  return count;
};

export const resetRowFilters = (filterTree) => {
  const tempTree = JSON.parse(JSON.stringify(filterTree));

  const resetFilter = (tree) => {
    const _tempTree = [];

    tree.forEach((obj) => {
      _tempTree.push({
        ...obj,
        isChecked: true,
        options:
          (obj?.options && obj.options.length) > 0
            ? resetFilter(obj.options)
            : [],
      });
    });

    return _tempTree;
  };

  return resetFilter(tempTree);
};

// to parse string example -> &gt;0 to >0
export const parseStringValue = (row) => {
  const htmlString = row;
  const temp = document.createElement('div');

  temp.innerHTML = htmlString;

  return temp.textContent;
};

export const setPersonalizedRows = (rowsTree, personalizedRows) => {
  const updateCheckedRecursive = (row) => {
    const currentRow = row;

    const parsedPersonalizedRows = personalizedRows.map((rowValue) =>
      parseStringValue(rowValue)
    );

    currentRow.isChecked = parsedPersonalizedRows?.includes(currentRow.value);

    row.options.forEach((option) => updateCheckedRecursive(option));
  };

  return rowsTree.forEach((item) => updateCheckedRecursive(item));
};

export const setPersonalizedCols = (columnsFilter, personalizedCols) => {
  const personalizedColsArray = Object.values(personalizedCols).flat();
  const personalizedColsIndexMap = new Map(
    personalizedColsArray.map((col, index) => [col, index])
  );

  return columnsFilter.map((columnTab) => {
    columnTab.options.forEach((column) => {
      // eslint-disable-next-line no-param-reassign
      column.isChecked = personalizedColsIndexMap.has(column.value);
    });

    columnTab.options.sort((a, b) => {
      const aIndex = personalizedColsIndexMap.get(a.value) ?? Infinity;
      const bIndex = personalizedColsIndexMap.get(b.value) ?? Infinity;

      return aIndex - bIndex;
    });

    return columnTab;
  });
};

export function checkAllPersonalizedColumnsExist(
  columnPickerList,
  personalizedColsFilters
) {
  if (columnPickerList && personalizedColsFilters) {
    const columnPickerListArray = Object.entries(columnPickerList).flatMap(
      ([key, value]) =>
        Object.keys(value).map((item) => `${key.toUpperCase()}-${item}`)
    );

    const personalizedColsFiltersArray = Object.values(
      personalizedColsFilters
    ).flat();

    return personalizedColsFiltersArray.every((item) =>
      columnPickerListArray.includes(item)
    );
  }

  return false;
}

export function checkAllPersonalizedRowsExist(
  isEOCampaign,
  viewRowsList,
  personalizedRowsFilters
) {
  const parsedPersonalizedRowsFilters = personalizedRowsFilters?.map(
    (rowValue) => parseStringValue(rowValue)
  );
  const personalizedRowsFiltersMapped = parsedPersonalizedRowsFilters?.map(
    (item) =>
      isEOCampaign ? EO_ROWS_CONSTANT_MAP[item] : ROWS_CONSTANT_MAP[item]
  );

  return personalizedRowsFiltersMapped?.every((row) =>
    viewRowsList.includes(row)
  );
}

export function checkAllPersonalizedFiltersExist(
  filters,
  personalizedAdvancedFilters
) {
  return (
    personalizedAdvancedFilters &&
    personalizedAdvancedFilters.every(
      ({ key }) =>
        // const filter = filters.find((item) => item.key === key);
        // CR-18530 changes
        filters.some((item) => item.key === key)
      // filter && filter.options.some((option) => option.value === value);
    )
  );
}
